var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonVTimeLineCorouselMonth',{ref:"timelines",attrs:{"query":"Web_Kommt_Geht_anzeige","monthBack":"6","expandPanel":true}})}
var staticRenderFns = []

export { render, staticRenderFns }